import React from 'react'
import { useStyles } from './styles'

function ButtonStackSpacer() {
  const { classes } = useStyles()

  return (
    <div className={classes.container} />
  )
}

export default React.memo(ButtonStackSpacer)
